import { useMutation } from '@tanstack/react-query';
import { HttpResponse } from 'store/APIClient';
import { useDispatch } from 'store/hooks';

export const useBaseSupportMutation = (
    mutationFn: (args: unknown) => Promise<HttpResponse<unknown>>,
    onSuccess?: () => void,
) => {
    const dispatch = useDispatch();
    return useMutation({
        mutationFn,
        onError: (error: Error) => {
            dispatch.vision.notifyUser({
                message: error.message,
                snackType: 'error',
            });
        },
        onSuccess: (response) => {
            if (onSuccess) onSuccess();

            dispatch.vision.notifyUser({
                message: response.content.message || '',
                snackType: response.content.message?.startsWith('warning')
                    ? 'warning'
                    : 'success',
            });
        },
    });
};
